import { noop } from '@tanstack/react-query';
import { bidsQuery, tenderBidDocumentsQuery } from '@/features/bids/queries';
import { Main, MainPending } from '@/ui/components/main';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout',
)({
  staticData: { chatSurface: 'bid_comparison' },
  component: RouteComponent,
  pendingComponent: MainPending,
  loader: (opts) => {
    opts.context.queryClient.query(tenderBidDocumentsQuery(opts.params.workspaceId)).catch(noop);
    return opts.context.queryClient.query({
      ...bidsQuery(opts.params.workspaceId),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  return (
    <Main>
      <Outlet />
    </Main>
  );
}
